
import {
  defineComponent, PropType, toRefs, computed,
} from 'vue';
import { CardDataImpl } from '@/interface/config.interface';
import { Uuid } from '@/lib';
import caseCardVue from './caseCard.vue';
import resultCardVue from '../teacher/jobAnalysis/resultCard.vue';

export default defineComponent({
  components: {
    caseCardVue,
    resultCardVue,
  },
  props: {
    /** 数据列表 */
    dataSource: {
      type: Array as PropType<Uuid<CardDataImpl>[]>,
      required: true,
    },
    /** 类型 - case|resource */
    cardType: {
      type: String as PropType<'case'|'resource'>,
      // required: true,
    },
  },
  emits: ['handleClick'],
  setup(props, { emit }) {
    const { dataSource: dataList } = toRefs(props);
    const layout = computed(() => (i: number) => ((i + 1) % 3 === 0 ? 'col' : 'row'));
    const handleClick = (item: CardDataImpl) => {
      emit('handleClick', item);
    };

    return {
      dataList,
      layout,
      handleClick,
    };
  },
});
